import React, { useEffect, useCallback } from 'react';
import { createPortal } from 'react-dom';
import CountryList from '../CountryList';

function CountrySearchModal({
  isOpen,
  onClose,
  countries = [],
  selectedCountry = null,
  onCountrySelect,
}) {
  const handleOverlayClick = useCallback(() => {
    onClose();
  }, [onClose]);

  const handlePanelClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  const handleCountrySelect = useCallback(
    (country) => {
      onCountrySelect?.(country);
      onClose();
    },
    [onCountrySelect, onClose]
  );

  useEffect(() => {
    if (!isOpen) return;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKeyDown);
    return () => document.removeEventListener('keydown', onKeyDown);
  }, [isOpen, onClose]);

  useEffect(() => {
    if (!isOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isOpen]);

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <div
      className="fixed inset-0 z-[11000] flex items-center justify-center bg-black/60 px-4 py-6"
      role="presentation"
      onClick={handleOverlayClick}
    >
      <div
        role="dialog"
        aria-modal="true"
        aria-labelledby="country-search-modal-title"
        className="relative flex h-[min(720px,90vh)] w-full max-w-md flex-col overflow-hidden rounded-2xl bg-white shadow-xl"
        onClick={handlePanelClick}
      >
        <CountryList
          countries={countries}
          selectedCountry={selectedCountry}
          onCountrySelect={handleCountrySelect}
          onRequestClose={onClose}
          helperText="Country Name / Area ISO"
          variant="modal"
          titleId="country-search-modal-title"
        />
      </div>
    </div>,
    document.body
  );
}

export default React.memo(CountrySearchModal);
